import styled from "styled-components";

export const MusicHallItemStyled = styled.div`
  .content_block {
    margin-bottom: 10px;
    cursor: pointer;
    .musichall_img {
      margin-bottom: 10px;
    }
    .musichall_inblock {
      .musichall_M1 {
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      }
      .musichall_price {
        margin-bottom: 2px;
        color: ${({ theme }) => theme.COLORS.BLACK_3};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      }
      .musichall_detail {
        min-height: 36px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${({ theme }) => theme.COLORS.GRAY_16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
    }
  }
  .btn_book_now {
    margin: auto;
    max-width: 215px;
  }

  &.theme_standard {
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .content_block {
      .btn_book_now {
        max-width: 100%;
      }
    }
  }
`;
